import {
  formatTimestampAsDateTime,
  parseTimestampForDisplay,
} from "../../utils/formatters";

/**
 * Refund-module date/time display (`Apr 30 2026, 08:19 PM`) — format only, no conversion.
 */
export function formatRefundDateTime(
  dateString: string | null | undefined,
): string {
  const raw = dateString != null ? String(dateString).trim() : "";
  if (!raw) return "";

  const formatted = formatTimestampAsDateTime(raw);
  if (formatted) return formatted;

  const date = parseTimestampForDisplay(raw);
  if (!date) return raw;

  const month = date.toLocaleString("en-US", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = (hours % 12 || 12).toString().padStart(2, "0");
  const displayMinutes = minutes.toString().padStart(2, "0");
  return `${month} ${day} ${year}, ${displayHours}:${displayMinutes} ${ampm}`;
}

/** API field names for ride / trip start (table, export, filters). */
export const REFUND_RIDE_START_DATE_KEYS = [
  "tripstartdate",
  "tripStartDate",
  "TripStartDate",
  "ridestartdate",
  "rideStartDate",
  "RideStartDate",
  "bookingstartdate",
  "bookingStartDate",
  "planstartdate",
  "planStartDate",
] as const;

/** API field names for ride end / completion (table, export, filters). */
export const REFUND_RIDE_END_DATE_KEYS = [
  "ridecompletedate",
  "rideCompleteDate",
  "RideCompleteDate",
  "tripenddate",
  "tripEndDate",
  "TripEndDate",
  "rideenddate",
  "rideEndDate",
  "RideEndDate",
  "bookingenddate",
  "bookingEndDate",
  "planenddate",
  "planEndDate",
] as const;

export function pickRefundRecordScalar(
  record: Record<string, unknown> | null | undefined,
  keys: readonly string[],
): unknown {
  if (!record) return undefined;
  for (const key of keys) {
    if (key in record && record[key] != null && record[key] !== "") {
      return record[key];
    }
  }
  return undefined;
}

/** Ride start date for refund list table / export. */
export function formatRefundRideStartDate(
  record: Record<string, unknown> | null | undefined,
): string {
  const raw = pickRefundRecordScalar(record, REFUND_RIDE_START_DATE_KEYS);
  return raw != null && String(raw).trim() !== ""
    ? formatRefundDateTime(String(raw))
    : "";
}

/** Ride end / completion date for refund list table / export. */
export function formatRefundRideEndDate(
  record: Record<string, unknown> | null | undefined,
): string {
  const raw = pickRefundRecordScalar(record, REFUND_RIDE_END_DATE_KEYS);
  return raw != null && String(raw).trim() !== ""
    ? formatRefundDateTime(String(raw))
    : "";
}
